module.exports = __webpack_public_path__ + "assets/img/modify.685f57f1.svg";